<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Search Ticket</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()" aria-label="Close"></button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-10">
        <input type="text" required class="textInputLong" name="ticketNumber" [(ngModel)]="ticketNumber" (keypress)="sharedService.isNumberKey($event)" />
      </div>
      <div class="col-2">
        <button class="btn btn-info" (click)="searchTicket()" [disabled]="detectEnableSearch()">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>

    @if (loanRequest != undefined) {
      <div>
        <hr />
        <div class="mt-1 fw-bold d-flex justify-content-end align-items-right gap-3">
          @if (loanRequest.Approved != undefined && loanRequest.Approved == true) {
            <h3 class="badge text-bg-success" style="font-size: 1.5rem">
              APPROVED
              @if (loanRequest.LoanID != undefined) {
                <i class="fas fa-check"></i>
              }
              |
              {{ loanRequest.ProcessedOn | date: "dd-MM-yyyy" }}
            </h3>
          }
          @if (loanRequest.Approved != undefined && loanRequest.Approved == false) {
            <h3 class="badge text-bg-danger" style="font-size: 1.5rem">DENIED | {{ loanRequest.ProcessedOn | date: "dd-MM-yyyy" }}</h3>
          }
          @if (loanRequest.Approved == undefined) {
            <h3 class="badge text-bg-primary" style="font-size: 1.5rem">PENDING</h3>
          }
          <h3>
            @if (loanRequest.LoanGroupId != undefined) {
              <span class="badge text-bg-primary"> <i class="far fa-handshake"></i></span>
            }
          </h3>
          @if (loanRequest.LoanID != undefined) {
            <h3 class="badge text-bg-primary text-uppercase" style="font-size: 1.5rem"><i class="fas fa-donate"></i> Has Loan</h3>
          }
        </div>
        <app-loan-request-details [request]="loanRequest" [isExpanded]="true" [editable]="false" [showPrevious]="false" [relatedCustomerIds]="relatedCustomerIds"></app-loan-request-details>
        <hr />
        @if (relatedList != undefined && relatedList.length > 0) {
          <div class="card" (click)="isCollapsed = !isCollapsed" style="cursor: pointer">
            <div class="card-header">
              <h3>Related Loans ({{ relatedList.length }})</h3>
            </div>
            <div class="card-body">
              <div id="collapseExample" [ngbCollapse]="isCollapsed">
                @for (r of relatedList; track r) {
                  <app-loan-request-details [request]="r" [isExpanded]="true" [editable]="false" [showPrevious]="false" [relatedCustomerIds]="relatedCustomerIds"></app-loan-request-details>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</form>
